module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp1_9005.1b32c95a.png";